import { render, staticRenderFns } from "./TagAdd.vue?vue&type=template&id=15079546&scoped=true&"
import script from "./TagAdd.vue?vue&type=script&lang=js&"
export * from "./TagAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15079546",
  null
  
)

export default component.exports